import AuthorizationFilter from "../Authorization/AuthorizationFilter";
import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import DateColumn from "@isceco/widget-library2/basic-elements/List/column/DateColumn.js";
import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import OptionalButtonCell from "../../components/StaticDetailList/OptionalButtonCell";

export default class ZVVMitgliederEinladungenColumns {

  static getColumns(isKi) {
    const roles = new AuthorizationFilter().roles
    if (roles.GP_SUPERUSER && isKi) {
      return [
        ZVVMitgliederEinladungenColumns.GP_ID_VNB_COLUMN(),
        ZVVMitgliederEinladungenColumns.EINLADUNGSDATUM_COLUMN(),
        ZVVMitgliederEinladungenColumns.GUELTIG_BIS_COLUMN(),
        ZVVMitgliederEinladungenColumns.ENTFERNEN_COLUMN()
      ]
    } else {
      return [
        ZVVMitgliederEinladungenColumns.GP_ID_VNB_COLUMN(),
        ZVVMitgliederEinladungenColumns.EINLADUNGSDATUM_COLUMN(),
        ZVVMitgliederEinladungenColumns.GUELTIG_BIS_COLUMN(),
      ]
    }
  }

  static getRowVariant() {
    return {
      get(row) {
        if (row.archivedAt) {
          return 'error'
        }
        return ''
      }
    }
  }

  static GP_ID_VNB_COLUMN() {
    return new StringColumn({
      key: 'gpIdVnb',
      text: 'zvv.mitglieder.einladungen.table.header.gpIdVnb',
    })
  }

  static EINLADUNGSDATUM_COLUMN() {
    return new DateColumn({
      key: 'createdAt',
      text: 'zvv.mitglieder.einladungen.table.header.einladungsdatum',
    })
  }

  static GUELTIG_BIS_COLUMN() {
    return new DateColumn({
      key: 'validUntil',
      text: 'zvv.mitglieder.einladungen.table.header.gueltigBis',
    })
  }

  static ENTFERNEN_COLUMN() {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new OptionalButtonCell({
        icon: 'trash alternate outline',
        variant: 'danger',
        show: row => !row.archivedAt,
      })
    })
  }
}
